import { Locale, locales } from "app-settings/localesAndCurrencies";

export type LocaleDirection = "ltr" | "rtl";

export function getLocaleDirection(locale: Locale): LocaleDirection {
  return locales[locale].dir;
}

export function isRtl(locale: Locale): boolean {
  return getLocaleDirection(locale) === "rtl";
}
